/* Libraries */
import color from 'color';

/* Styles */
import { black, pinkA400, white } from './colors';

/* Types */
import type { Theme } from '../types';

const DefaultTheme: Theme = {
	dark: false,
	roundness: 4,
	colors: {
		primary: '#1B1464',
		secondary: '#DAEDFB',
		accent: '#F9F9F9',
		accentDisabled: '#D9D4D4',
		background: white,
		surface: white,
		error: '#B00020',
		text: '#333333',
		onSurface: '#1B1464',
		disabled: color(black).alpha(0.26).rgb().string(),
		placeholder: color(black).alpha(0.54).rgb().string(),
		backdrop: color(black).alpha(0.5).rgb().string(),
		notification: pinkA400,
	}
};

export default DefaultTheme;
